import colors from 'tailwindcss/colors'
import {
    CandidateLiteDto,
    InterestedValues,
    PresentCandidateValues,
} from '../../api/role/models/CandidateDto'

export type PersonNodeStatus =
    | 'shortlisted'
    | 'not_shortlisted'
    | 'contacted'
    | 'interested'
    | 'not_interested'
    | 'needs_review'

export type PersonNodeStatusLabel =
    | 'Shortlisted'
    | 'Not Shortlisted'
    | 'Contacted'
    | 'Interested'
    | 'Not Interested'
    | 'Needs Review'

export type CandidateStatusInfo = {
    status: PersonNodeStatus
    statusLabel: string
    colourHex: string
    bgColourTailwindName: string
}

export function getCandidateStatusInfo(
    candidate: CandidateLiteDto,
): CandidateStatusInfo {
    // if interested is no then return not_interested and red-500
    // if interested is yes then return interested and green-500
    // if contacted is yes then return contacted and orange-500
    // if shortlisted is no then return not_shortlisted and red-500
    // if shortlisted is yes then return shortlisted and ctxt-blue

    if (candidate.interested === InterestedValues.NO) {
        return {
            status: 'not_interested',
            statusLabel: 'Not Interested',
            colourHex: colors.red[500],
            bgColourTailwindName: 'bg-red-500',
        }
    } else if (candidate.interested === InterestedValues.YES) {
        return {
            status: 'interested',
            statusLabel: 'Interested',
            colourHex: colors.green[500],
            bgColourTailwindName: 'bg-green-500',
        }
    }

    if (candidate.contacted) {
        return {
            status: 'contacted',
            statusLabel: 'Contacted',
            colourHex: colors.orange[500],
            bgColourTailwindName: 'bg-orange-500',
        }
    }

    if (!candidate.present) {
        return {
            status: 'needs_review',
            statusLabel: '',
            colourHex: colors.gray[500],
            bgColourTailwindName: 'bg-gray-500',
        }
    } else if (candidate.present === PresentCandidateValues.NO) {
        return {
            status: 'not_shortlisted',
            statusLabel: 'Hidden',
            colourHex: colors.red[500],
            bgColourTailwindName: 'bg-red-500',
        }
    } else if (candidate.present === PresentCandidateValues.YES) {
        return {
            status: 'shortlisted',
            statusLabel: 'Saved',
            colourHex: colors.green[600],
            bgColourTailwindName: 'bg-green-600',
        }
    }

    throw new Error(
        `Unknown candidate status: ${candidate.present} for candidate ${candidate.candidatePersonId}`,
    )
}
